<template>
    <div class="w-full" :class="divClasses">
        <DatePicker v-model="value" fluid v-bind="calendarAttrs" :invalid="error" @date-select="selectDate" @input="inputDate" @today-click="selectToday" @clear-click="clearDate" />
        <small v-if="error" class="p-error">{{error}}</small>
    </div>
</template>

<script>
import DatePicker from 'primevue/datepicker';

export default {
    inheritAttrs: false,
    components: { DatePicker },
    props: {
        modelValue: {
			type: [String, Number, Date],
			default: null
		},
		error: {
			type: String,
			default: null
		}
    },
    data(){
        return {
            value: this.modelValue
        }
    },
    computed: {
        divClasses() {
            return this.$attrs.class || '';
        },
        calendarAttrs() {
            const rest = { ...this.$attrs };
            delete rest.class;
            return rest;
        }
    },
    methods: {
        selectDate(value){
            this.$emit('update:modelValue', value);
        },
        inputDate(event){
            this.$emit('update:modelValue', event.target.value);
        },
        selectToday(value){
            this.$emit('update:modelValue', value)
        },
        clearDate(){
            this.$emit('update:modelValue', '')
        }
    }
}
</script>